// Deutschland
export default {
	title: "VIP-Level",
	current: "Aktuelles VIP-Level",
	status: {
		btn: ["Aktiviert", "Jetzt registrieren"]
	}
};
